export default "__VITE_ASSET__27524b36__"